AgrimarketControllers.controller('contributionsController', [
    '$scope', '$rootScope', '$location', 'colonnes', 'contributionsService', 'configurationFactory', 'parametersFactory', 'currentUserFactory',
    function ($scope, $rootScope, $location, colonnes, contributionsService, configurationFactory, parametersFactory, currentUserFactory) {

        if (!$rootScope.ModuleMyAccount.Active)
            $location.path('/');

        
    }
]);